import * as echarts from "echarts";
import { i18n } from "../../../../language";
import store from "../../../../store";

let isDarkMode = () => store.state.user.darkMode;
var cellSize = [80, 80];
var pieRadius = 30;

export function getPieSeries(scatterData, chart) {
    let series = scatterData.map((item, index) => {
        let center = chart.convertToPixel("calendar", item);
        return {
            id: index + "pie",
            type: "pie",
            center: center,

            tooltip: {
                trigger: "item",
                formatter: (a, b) => {
                    let { name, value } = a.data;
                    value = parseFloat(value);
                    if (value < 1) {
                        value = Math.ceil(value * 60);
                        return i18n.t("message.calendarPassedTimeMin", {
                            value,
                            name,
                        });
                    } else {
                        const hour = Math.floor(value);
                        let min = value - hour;
                        min = Math.ceil(min * 60);
                        if (min >= 1) {
                            //return `${hour} saat ${min} dk boyunca ${name}`
                            return i18n.t("message.calendarPassedTime", {
                                hour,
                                min,
                                name,
                            });
                        } else {
                            // return `${hour} saat  boyunca ${name}`
                            return i18n.t("message.calendarPassedTimeHour", {
                                hour,
                                name,
                            });
                        }
                    }
                },
            },
            label: {
                normal: {
                    show: false,
                    formatter: "{c}",
                    position: "inside",
                },
            },
            radius: pieRadius,
            data: [
                {
                    name: i18n.t("message.online"),
                    value: parseFloat(item[1].online).toFixed(1),
                    itemStyle: { color: "#1BADA8" },
                },
                {
                    name: i18n.t("message.away"),
                    value: parseFloat(item[1].away).toFixed(1),
                    itemStyle: { color: "#3699ff" },
                },
                {
                    name: i18n.t("message.busy"),
                    value: parseFloat(item[1].busy).toFixed(1),
                    itemStyle: { color: "#FFA800" },
                },
                {
                    name: i18n.t("message.offline"),
                    value: parseFloat(item[1].offline).toFixed(1),
                    itemStyle: { color: "#F64E60" },
                },
                {
                    name: i18n.t("message.disconnected"),
                    value: parseFloat(item[1].disconnected).toFixed(1),
                    itemStyle: { color: "#838383" },
                },
            ],
        };
    });
    chart.setOption({
        series: [
            {
                id: "label",
                type: "scatter",
                coordinateSystem: "calendar",
                symbolSize: 1,
                label: {
                    normal: {
                        show: true,
                        formatter: function (params) {
                            return echarts.format.formatTime("dd", params.value[0]);
                        },
                        offset: [-cellSize[0] / 2 + 10, -cellSize[1] / 2 + 10],
                        textStyle: {
                            color: isDarkMode() ? "white" : "black",
                            fontSize: 14,
                        },
                    },
                },
            },
            ...series,
        ],
    });
}

export default (range, scatterData, title) => {
    return {
        title: {
            show: false,
            text: title || "",
            textStyle: {
                color: "#448aff",
                fontSize: 15,
            },
            left: "30%",
        },
        tooltip: {},
        legend: {
            data: [
                i18n.t("message.online"),
                i18n.t("message.away"),
                i18n.t("message.busy"),
                i18n.t("message.offline"),
                i18n.t("message.disconnected"),
            ],
            textStyle: {
                color: isDarkMode() ? "white" : "black",
            },
            orient: "vertical",
            right: 0,
            bottom: 0,
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    pixelRatio: 2,
                    title: i18n.t("message.download"),
                },
            },
        },
        calendar: {
            top: "middle",
            left: "center",
            orient: "vertical",
            cellSize: cellSize,
            itemStyle: {
                color: isDarkMode() ? "#333440" : "white",
            },
            yearLabel: {
                show: false,
                textStyle: {
                    fontSize: 30,
                    color: isDarkMode() ? "white" : "black",
                },
            },
            dayLabel: {
                margin: 20,
                firstDay: 1,
                nameMap: [
                    i18n.t("message.sunday"),
                    i18n.t("message.monday"),
                    i18n.t("message.tuesday"),
                    i18n.t("message.wednesday"),
                    i18n.t("message.thursday"),
                    i18n.t("message.friday"),
                    i18n.t("message.saturday"),
                ],
                textStyle: {
                    color: isDarkMode() ? "white" : "black",
                },
            },
            monthLabel: {
                show: false,
            },
            range,
        },
        series: [
            {
                id: "label",
                type: "scatter",
                coordinateSystem: "calendar",
                symbolSize: 1,
                label: {
                    normal: {
                        show: true,
                        formatter: function (params) {
                            return echarts.format.formatTime("dd", params.value[0]);
                        },
                        offset: [-cellSize[0] / 2 + 10, -cellSize[1] / 2 + 10],
                        textStyle: {
                            color: isDarkMode() ? "white" : "black",
                            fontSize: 14,
                        },
                    },
                },
                data: scatterData,
            },
        ],
    };
};
